declare var require: any;
const locale = require('element-ui/lib/locale/lang/zh-CN');
const zh = {
    ...locale.default,

    "home": "首页",
    "browse": "搜索",
    "visualization": "可视化",
    "tools": "工具",
    "help": "帮助",
    "hylacticPneumonia": "过敏性肺炎",
    "view": "查看",
    "multipleOmics": "多组学",
    "dataStatistics": "数据统计",
    "species": "物种",
    "disease": "疾病",
    "sequencingType": "测序类型",
    "sample": "样本",
    "cellTissueType": "细胞/组织类型",
    "ds": "数据集",
    "print": "出版物",
    "cellNumber": "细胞数",
    "dataset": "实验数据集",
    "dataAnalyze": "数据分析",
    "visual": "可视化",
    "pulmonaryTuberculosis": "肺结核",
    "exploreTool": "可视化工具",
    "tissue": "Tissue",
    "libraryPreparationProtocol": "Library Preparation Protocol",
    "pval": "P_val",
    "avgLog2fc": "Avg_log2FC",
    "pct1": "Pct.1",
    "pct2": "Pct.2",
    "pvalAdj": "P_val_adj",
    "cellType": "Cell Type",
    "gene": "Gene",
    "cellBrowser": "细胞浏览器",
    "geneBrowser": "基因浏览器",
    "circleMap": "圆环图",
    "volcanoMap": "火山图",
    "spatialTranscriptomeBrowser": "空间转录组浏览器",
    "apply": "应用",
    "tissueType": "组织类型",
    "diseases": "疾病",
    "samples": "样本",
    "publications": "出版物",
    "cellNumbers": "细胞数",
    "cellTypes": "细胞类型",
    "tissueTypes": "组织类型",
    "differentiallyExpressedGenes": "差异基因数",
    "datasetId": "数据集Id",
    "projectId": "项目Id",
    "libraryProtocol": "库协议",
    "cluster": "Cluster",
    "chrom": "Chromsome",

    "health": "健康数据浏览",
    "respiratoryDisease": "疾病数据浏览",
    "respiratorySystemCancer": "呼吸系统肿瘤",
    "lowerRespiratoryIllnessess": "下呼吸道疾病",
    "respiratoryInfectiousDisease": "呼吸道传染疾病",
    "lungCancer": "肺癌",
    "smallCell": "小细胞肺癌",
    "Non-smallLung": "非小细胞肺癌",
    "Non-smallAdenocarcinoma": "非小细胞肺腺癌",
    "Non-smallCell": "非小细胞肺鳞癌",
    "bronchialDisease": "支气管疾病",
    "asthma": "哮喘",
    "lungDisease": "肺部疾病",
    "interstitialLungDisease": "间质性肺病",
    "pulmonaryFibrosis": "肺纤维化",
    "ipf": "特发性肺纤维化",
    "extrinsicAllergicAlveolitis": "外源性过敏性肺炎",
    "chronicObstructivePneumonia": "慢性阻塞性肺炎",
    "cysticFibrosis": "囊性纤维化",
    "viralRespiratory": "病毒性呼吸道传染病",
    "grippe": "流感",
    "COVID19": "COVID-19",
    "cytomegalovirusInfection": "巨细胞病毒感染",
    "tuberculosis": "结核病",
    "bacterialPneumonia": "细菌性肺炎",
    "klebsiellaPneumonia": "克雷伯菌肺炎",
    "ventilatorAssociatedPneumonia": "呼吸机相关性肺炎",
    "other": "其他",
    "senility": "衰老",
    "smoke": "香烟暴露",

    "singleCellRNASeqDesc": "单细胞转录组模块包含不同疾病,不同组织下细胞类型之间的基因表达差异,可以用于发现疾病和细胞类型的标志物",
    "RNASeqDesc": "转录组模块包含了不同的处理因素下的差异基因,可以用于发现呼吸系统疾病状态与非疾病状态,不同的组织或者细胞类型下的标准物",
    "singleCellATACSeqDesc": "单细胞表观组检测单个细胞的染色质开放性信息,通过基因的启动子区域开放情况构建基因的活性矩阵,该模块包含不同细胞类型的活性基因的差异",
    "ATACSeqDesc": "表观组包含染色质在全基因组范围内的可及性的基因组注释信息,以研究在不同处理因素下基因的表达调控关系",
    "singleCellTCRSeqDesc": "单细胞TCR模块从成对的单细胞RNA测序读数中识别和组装全长重排的V(D)J T细胞受体序列.它可以用来估计免疫系统的多样性，并探索免疫组的剧目与疾病之间的关系。",
    "TCRSeqDesc": "T细胞表面受体(TCR)存在VDJ基因重排现象,这决定了TCR的免疫多样性，并在抗原识别中起关键作用,TCR-seq模块数据包含不同疾病和组织的VDJ克隆型的注释信息",
    "CITESeqDesc": "单细胞多模态模块包含CITE-seq数据,CITE-seq可以在测得单细胞表达的同时测得与制备的抗体(ADT)结合表面受体蛋白的丰度,该模块包含了在不同疾病,不同组织下细胞类型之间的基因表达和表面蛋白丰度的差异",
    "spatialTranscripomics": "空间转录组模块同时获取组织在细胞或亚细胞水平上空间位置和表达情况",
    "transcriptomics" : "转录组",
    "genomics": "基因组学",
    "immunomics": "免疫组学",
    "spatialTranscriptomics": "空间转录组",
    "epigenomics": "表观遗传组",
    "multimodal": "单细胞多模态",
    "GWASDesc": "GWAS经过统一处理的精细映射，包含相关表型的因果突变位点信息。",
    "traits": "特征",
    "mesh": "医学主题词",
    "SNP": "SNP",

    "jobSuccess": "操作成功",
    "emailSuccess": "已发送至邮箱",
    "jobError": "运行失败",
    "datacenter": "数据中心",
    "dataerror": "数据不存在!",
    "downerror": "生成下载链接时出错:",
}

export default zh;
